const standaloneMedia = window.matchMedia('(display-mode: standalone)');
const isIos =
    /iPad|iPhone|iPod/.test(window.navigator.userAgent) ||
    (window.navigator.platform === 'MacIntel' && window.navigator.maxTouchPoints > 1);
const listeners = new Set();
let deferredPrompt = null;
let installed = false;
let flow = null;

const update = () => {
    const standalone = standaloneMedia.matches || window.navigator.standalone === true;
    const next = installed || standalone ? null : isIos ? 'ios' : deferredPrompt ? 'native' : null;

    if (next !== flow) {
        flow = next;
        listeners.forEach((listener) => listener());
    }
};

// Imported at bootstrap: capture availability even before login/sidebar mounting.
window.addEventListener('beforeinstallprompt', (event) => {
    event.preventDefault();
    deferredPrompt = event;
    update();
});

window.addEventListener('appinstalled', () => {
    installed = true;
    deferredPrompt = null;
    update();
});

if (standaloneMedia.addEventListener) standaloneMedia.addEventListener('change', update);
else standaloneMedia.addListener(update);
update();

const subscribe = (listener) => {
    listeners.add(listener);
    return () => listeners.delete(listener);
};

// Call only from the sidebar click. A consumed/dismissed event cannot be prompted twice.
const install = async () => {
    if (flow !== 'native' || !deferredPrompt) return;
    const event = deferredPrompt;

    deferredPrompt = null;
    update();
    try {
        await event.prompt();
        const {outcome} = await event.userChoice;

        if (outcome === 'accepted') {
            installed = true;
            deferredPrompt = null;
        }
    } finally {
        update();
    }
};

export default {subscribe, getSnapshot: () => flow, install};
